import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './styles/TeacherListPage.css';
import { FaEye, FaEdit } from 'react-icons/fa';
import { FaMoneyCheckDollar, FaMoneyBills  } from "react-icons/fa6";



const TeacherListPage = () => {
    const [branchList, setBranchList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [teachers, setTeachers] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [selectedBranch, setSelectedBranch] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalData, setTotalData] = useState(0); 
    const navigate = useNavigate();
    const [isSearched, setIsSearched] = useState(false);

    // Fetch branch list when component mounts
    useEffect(() => {
        const fetchBranchList = async () => {
            try {
                const response = await api.get('/utils/getBranchList');
                const branches = response.data.data.branchList.map(branch => ({
                    id: branch.branch_id,
                    name: `${branch.branch_code} - ${branch.branch_name}`,
                }));
                setBranchList(branches);
            } catch (error) {
                console.error("Failed to fetch branch list", error);
            }
        };

        const fetchStatusList = async () => {
            try {
                const response = await api.get('/utils/getTeacherStatusList');
                const statuses = response.data.data.statusList.map(status => ({
                    id: status.status_id,
                    name: `${status.status_name}`,
                }));
                setStatusList(statuses);
            } catch (error) {
                console.error("Failed to fetch status list", error);
            }
        };

        fetchStatusList();
        fetchBranchList();
        
    }, []);

    useEffect(() => {
        if (isSearched) {
            handleSearch(); 
        }
    }, [currentPage, isSearched]);

    const handleSearch = async () => {
        try {
            const response = await api.post('/teacher/getTeacherListByFilter', {
                data: [{
                    teacher_name: searchName,
                    branch_id: selectedBranch,
                    status_id: selectedStatus,
                }],
                limit: 25, 
                page: currentPage 
            });
            setTeachers(response.data.data.teacherList);
            setTotalData(response.data.data.totalCount); 
            setTotalPages(Math.ceil(response.data.data.totalCount / 25)); 

            const totalCount = response.data.data.totalCount;
            
            if (totalCount > 0) {
                setTotalPages(Math.ceil(totalCount / 25));
                if(totalPages < currentPage){
                    setCurrentPage(1);
                }
            } else {
                setCurrentPage(1);
                setTotalPages(1);
            }

            setIsSearched(true);
        } catch (error) {
            console.error("Failed to fetch teachers", error);
        }
    };
    

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const handleViewDetails = (teacherId) => {
        navigate(`/teacher/detail/${teacherId}`);
    };

    const handleEditDetails = (teacherId) => {
        navigate(`/teacher/edit/${teacherId}`);
    };
    
    const handleInputTeacherBonus = (teacherId) => {
        navigate(`/teacher/bonus/create/${teacherId}`);
    };

    const handleTeacherSalary = (teacherId) => {
        navigate(`/teacher/salaryDetail/${teacherId}`);
    };

    return (
        <div className="teachers-page">
            <div className="page-title">Teacher List</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Teacher Name</label>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Enter teacher name"
                                            value={searchName}
                                            onChange={(e) => setSearchName(e.target.value)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Branch</label>
                                    </td>
                                    <td>
                                        <select
                                            value={selectedBranch}
                                            onChange={(e) => setSelectedBranch(e.target.value)}
                                        >
                                            <option value="">Select Branch</option>
                                            {branchList.map(branch => (
                                                <option key={branch.id} value={branch.id}>
                                                    {branch.name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Status</label>
                                    </td>
                                    <td>
                                        <select
                                            value={selectedStatus}
                                            onChange={(e) => setSelectedStatus(e.target.value)}
                                        >
                                            <option value="">Select Status</option>
                                            {statusList.map(status => (
                                                <option key={status.id} value={status.id}>
                                                    {status.name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <button onClick={handleSearch}>Search</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="section">
                    <div className="teachers-list">
                        <table>
                            <thead>
                                <tr>
                                    <th class="no-column">No</th>
                                    <th>Teacher Name</th>
                                    <th>NIK</th>
                                    <th>Username</th>
                                    <th>Role</th>
                                    <th>Branch</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {teachers.map((teacher, index) => (
                                    <tr key={teacher.teacher_id}>
                                        <td class="no-column">{index + 1 + (currentPage - 1) * 25}</td>
                                        <td>{teacher.teacher_name}</td>
                                        <td>{teacher.teacher_code}</td>
                                        <td>{teacher.User.username}</td>
                                        <td>{teacher.User.Role.name}</td>
                                        <td>{teacher.Branch ? teacher.Branch.branch_name : ""}</td>
                                        <td>{teacher.TeacherStatus.Status.status_name}</td>
                                        <td>
                                            <FaEye className="action-icon" title="View Details" onClick={() => handleViewDetails(teacher.teacher_id)} />
                                            <FaEdit className="action-icon" title="Edit Teacher" onClick={() => handleEditDetails(teacher.teacher_id)} />
                                            {teacher.TeacherBonus.length == 0 &&
                                            <FaMoneyCheckDollar className="action-icon" title="Input Teacher Bonus" onClick={() => handleInputTeacherBonus(teacher.teacher_id)} />
                                            }
                                            <FaMoneyBills  className="action-icon" title="Teacher Salary" onClick={() => handleTeacherSalary(teacher.teacher_id)} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="total-data">
                        <span>Total Data: {totalData}</span>
                    </div>
                    <div className="pagination">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <button onClick={handlePrevPage} disabled={currentPage === 1}>
                                            Prev
                                        </button>
                                    </td>
                                    <td>
                                        <span>Page {currentPage} of {totalPages}</span>
                                    </td>
                                    <td>
                                        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                                            Next
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeacherListPage;
